const common = {
  "user": {
    "unknown": "(មិនស្គាល់)"
  },
  "queryState": {
    "imageLoading": "កំពុងផ្ទុករូបភាព",
    "retry": "ព្យាយាមម្តងទៀត",
    "loadFailedGeneric": "មិនអាចផ្ទុកទិន្នន័យបានទេ",
  },
  "reviewMode": {
    "label": "របៀបពិនិត្យ",
    "exit": "ចេញពីរបៀបពិនិត្យ",
  },
  "notCompleted": {
    "view3d": "3D (mesh) មិនទាន់បានបង្កើតនៅឡើយទេ",
    "view2d": "2D (រូបភាព orthomosaic · DEM) មិនទាន់បានបង្កើតនៅឡើយទេ",
    "values": "{{dates}}: មិនបានគណនាទេ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
    "issueWrite": "មិនអាចរក្សាទុកកូអរដោនេបញ្ហាបានទេ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
    "tools3d": "មិនអាចបង្កើតបញ្ហា និងវាស់ប្រវែងបណ្ដោយបានទេ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
    "profile": "មិនអាចមើលផ្នែកកាត់បានទេ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
    "coordinates": "មិនអាចកែកូអរដោនេបានទេ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
    "write": "អាចត្រឹមតែមើលបានប៉ុណ្ណោះ ព្រោះដំណើរការមិនទាន់បញ្ចប់នៅឡើយ",
  },
  "colorPicker": {
    "changeColor": "ប្តូរពណ៌: {{target}}",
  },
  "folder": {
    "newFolder": "ថតថ្មី",
    "newFolderNamed": "ថតថ្មីក្នុង {{name}}",
    "createChild": "បង្កើតថតរង",
    "rename": "ប្ដូរឈ្មោះ",
    "duplicate": "ចម្លង",
    "duplicating": "កំពុងចម្លង…",
    "move": "ផ្លាស់ទី",
    "moveToFolder": "ផ្លាស់ទីទៅថត",
    "moveUp": "ផ្លាស់ទីឡើងលើ",
    "moveDown": "ផ្លាស់ទីចុះក្រោម",
    "delete": "លុប",
    "cancel": "បោះបង់",
    "root": "កម្រិតកំពូល",
    "moveTargets": "ទីតាំងផ្លាស់ទី",
    "nameInput": "ឈ្មោះថត",
    "saveName": "រក្សាទុកឈ្មោះ",
    "cancelName": "បោះបង់ការកែ",
    "itemCount": "{{count}} ធាតុ",
    "folderMenu": "ម៉ឺនុយថត: {{name}}",
    "itemMenu": "ម៉ឺនុយធាតុ: {{name}}",
    "lock": "ចាក់សោ",
    "unlock": "ដោះសោ",
    "lockedRow": "បានចាក់សោ: {{name}}",
    "showToggle": "បង្ហាញថត: {{name}}",
    "sizePartial": "{{size}} ឬច្រើនជាងនេះ",
    "deleteTitle": "លុបថត",
    "deleteMessage": "លុបថត '{{name}}'?",
    "deleteMessageWithSubfolders": "លុប '{{name}}' និងថតរងរបស់វា (សរុប {{count}} ថត)?",
    "deleteSubMessage": "ធាតុ {{count}} នៅខាងក្នុងនឹងចេញពីថត ហើយទិន្នន័យមិនត្រូវបានលុបទេ។",
    "deleteSubMessageWithItems": "ធាតុ {{count}} នៅខាងក្នុងក៏នឹងត្រូវលុបដែរ។",
    "deleteSubMessageNoItems": "គ្មានធាតុនៅក្នុងថតទេ ដូច្នេះមានតែថតប៉ុណ្ណោះដែលត្រូវបានលុប។",
    "loadFailedNamed": "មិនអាចផ្ទុកថត {{name}} បានទេ",
    "selectedCount": "បានជ្រើសរើស {{count}}",
    "selectionHint": "អូសពួកវាជាមួយគ្នាទៅក្នុងថតតែមួយ",
    "selectionMaxed": "នេះជាចំនួនអតិបរមាដែលអាចផ្លាស់ទីក្នុងពេលតែមួយ",
    "clearSelection": "សម្អាតការជ្រើសរើស",
    "error": {
      "forbidden": "អ្នកមិនមានសិទ្ធិកែប្រែថតទេ។",
      "notFound": "រកមិនឃើញថត ឬធាតុទេ។ កំពុងផ្ទុកបញ្ជីឡើងវិញ។",
      "failed": "សកម្មភាពថតបានបរាជ័យ។",
      "notSent": "មិនអាចផ្ញើសកម្មភាពថតបានទេ។ សូមព្យាយាមម្តងទៀតបន្តិចក្រោយ។",
      "uploadNotPlaced": "មិនអាចដាក់ឯកសារដែលបានផ្ទុកឡើងចូលក្នុងថតបានទេ ដូច្នេះបានទុកវានៅកម្រិតកំពូល។",
      "moveTooMany": "អាចផ្លាស់ទីបានរហូតដល់ {{max}} ធាតុក្នុងពេលតែមួយ។ សូមដកការធីកខ្លះចេញ ហើយអូសម្តងទៀត។"
    }
  },
  "projects": {
    "projectInfo": "ព័ត៌មានគម្រោង",
    "application": "កម្មវិធី",
    "projectList": "បញ្ជីគម្រោង",
    "checkingApplication": "ការត្រួតពិនិត្យ 2D(រូបភាព) & 3D(គំរូ)",
    "portinfraApplication": "ការត្រួតពិនិត្យសុវត្ថិភាពហេដ្ឋារចនាសម្ព័ន្ធច្រក",
    "slopeAppication": "ការថែទាំទីជម្រាល",
    "constructingApplication": "ការត្រួតពិនិត្យសុវត្ថិភាពហេដ្ឋារចនាសម្ព័ន្ធច្រក",
    "cadastralApplication": "ការគ្រប់គ្រងផែនទីដី(Beta)",
    "managingDroneImages": "រូបភាពដ្រូន",
    "droneImages": "ការជ្រើសតម្រួតរូបភាពដ្រូន",
    "summaryMapping": "សង្ខេបការជ្រើសតម្រួតរូបភាព",
    "waitingMapping": "រង់ចាំការជ្រើសតម្រួត",
    "managingProjectGroup": "ក្រុមគម្រោង",
    "managingEtcData": "ទិន្នន័យផ្សេងៗ",
    "roadIssue": "ការរកឃើញបញ្ហាកៀស",
    "newProject": "គម្រោងថ្មី",
    "newProjectCreate": "បង្កើតគម្រោងថ្មី",
    "droneImagesCount": "ចំនួនរូបភាពដ្រូន",
    "droneImageMapping": "ការជ្រើសតម្រួតរូបភាព",
    "imageMapingProcess": "ដំណើរការជ្រើសតម្រួតរូបភាព",
    "processCondition": "ស្ថានភាពដំណើរការ",
    "orthomosaicDown": "រូបភាព Orthomosaic [TIF]",
    "pointcloudDown": "ពពក 3D [LAS]",
    "meshDown": "ណែត 3D [OBJ]",
    "dsmDown": "គំរូផ្ទៃដីតម្លោយ [DSM-TIF]",
    "dataDown": "ទាញយកលទ្ធផលការជ្រើសតម្រួតរូបភាព",
    "message": {
      "failedCreatingContent": "បង្កើតការបង្ហោះបានបរាជ័យ",
      "deletedContent": "លុបការបង្ហោះបានជោគជ័យ",
      "failedDeletedContent": "លុបការបង្ហោះបានបរាជ័យ",
      "makeSureDeleteProject": "តើអ្នកចង់លុបគម្រោងនេះ?",
      "makeSureDeleteTimeSeries": "តើអ្នកពិតជាចង់លុបស៊េរីពេលវេលា?",
      "warningDeleteTimeSeries": "ប្រតិបត្តិការនេះមិនអាចត្រឡប់វិញបានទេ។\n ការលុបស៊េរីពេលវេលានឹងដកយកទិន្នន័យទាំងអស់ដែលទាក់ទង ហើយព័ត៌មានទាំងអស់ដូចជាបញ្ហា ការវាស់ស្ទង់ និងរបាយការណ៍នឹងត្រូវបានលុបជាអចិន្ត្រៃយ៍។",
      "processingMapping": "អាចមើលបានបន្ទាប់ពីដំណើរការជ្រើសតម្រួតរូបភាពដ្រូនបានបញ្ចប់",
      "processingMappingDownload": "អាចទាញយកទិន្នន័យបន្ទាប់ពីដំណើរការជ្រើសតម្រួតរូបភាពដ្រូនបានបញ្ចប់",
      "accessDeniedAdmin": "គណនីអ្នកគ្រប់គ្រងមិនអាចចូលបានទេ",
      "makeSureModifyProject": "តើអ្នកចង់កែប្រែគម្រោងនេះ?",
      "makeSureDeleteFolder": "តើអ្នកចង់លុបថតនេះ?",
      "successUpload": "បង្ហោះបានជោគជ័យ",
      "failedUpload": "បង្ហោះបានបរាជ័យ",
      "uploadedImage": "រូបភាពដែលបានបង្ហោះ",
      "refreshAfterUploaded": "សូមចុចប៊ូតុងតាំងពិតថ្មីបន្ទាប់ពីការបង្ហោះបានបញ្ចប់។",
      "imageDeleteCompleted": "ការលុបរូបភាពបានបញ្ចប់។",
      "imageUpload10": "ត្រូវបង្ហោះរូបភាពយ៉ាងតិច ១០ ។",
      "notSelectedImage": "សូមជ្រើសរើសរូបភាព។",
      "deleteCompleted": "ការលុបបានជោគជ័យ។",
      "failedDeleting": "ការលុបបានបរាជ័យ។",
      "typeProjectName": "សូមបញ្ចូលឈ្មោះគម្រោង។",
      "deleteTimeSeries": "លុបស៊េរីពេលវេលា",
      "ifYouWantToDeleteTimeSeries": "ប្រសិនបើអ្នកចង់លុបស៊េរីពេលវេលាខាងលើ",
      "addTimeSeries": "បន្ថែមស៊េរីពេលវេលា",
      "duplicateTimeSeries": "ស៊េរីពេលវេលានៃថ្ងៃតែមួយមានស្រាប់។",
      "failedCreating": "ការបង្កើតបានបរាជ័យ",
      "successCreating": "ការបង្កើតបានជោគជ័យ"
    }
  },
  "auth": {
    "message": {
      "loginFailed": "ការចូលប្រព័ន្ធបានបរាជ័យ",
      "confirmFailed": "ការផ្ទៀងផ្ទាត់បានបរាជ័យ",
      "resendingConfirmationCode": "បានផ្ញើលេខកូដផ្ទៀងផ្ទាត់ឡើងវិញ។",
      "confirmationCodeResendingFail": "ការផ្ញើឡើងវិញបានបរាជ័យ",
      "fillEmail": "សូមបញ្ចូលអ៊ីមែលដែលបានចុះឈ្មោះ។",
      "sendCodeNumber": "នឹងផ្ញើលេខកូដផ្ទៀងផ្ទាត់ទៅអ្នក។",
      "sentCodeNumber": "បានផ្ញើលេខកូដផ្ទៀងផ្ទាត់រួចហើយ។",
      "sendCodeNumberFailed": "ការផ្ញើលេខកូដបានបរាជ័យ",
      "changePassWordFailed": "ការផ្លាស់ប្ដូរពាក្យសម្ងាត់បានបរាជ័យ",
      "notMatchCode": "លេខកូដផ្ទៀងផ្ទាត់ត្រូវតែជាលេខ ៦ ខ្ទង់។"
    }
  },
  "inspection2d": {
    "projectInfo": "ព័ត៌មានគម្រោង",
    "projectModify": "កែប្រែព័ត៌មានគម្រោង",
    "layerInfo": "ស្រទាប់",
    "issueInfo": "បញ្ហា/ការវាស់ស្ទង់",
    "managingBim": "ការគ្រប់គ្រង 3D",
    "report": "របាយការណ៍",
    "mainLayer": "ស្រទាប់ចម្បង",
    "issueType": "ប្រភេទបញ្ហា",
    "issueName": "ឈ្មោះបញ្ហា",
    "createIssue": "បង្កើតបញ្ហា",
    "typeByXY": "កូអរដោនេ X-Y",
    "typeByLatLng": "កូអរដោនេ Lat/Lng",
    "issueList": "បញ្ជីបញ្ហា",
    "issueDegree": "កម្រិតបញ្ហា",
    "msg": {
      "nonNegativeNumber": "តម្លៃកម្ពស់ត្រូវតែជាលេខវិជ្ជមាន។",
      "tooSmallArea": "ទទឹងសម្រាប់ទទួលបានព័ត៌មានបរិមាណតូចពេក។",
      "notAnyMatchIssue": "មិនមានបញ្ហាដែលត្រូវគ្នា។",
      "makeIssue": "សូមចុះឈ្មោះបញ្ហា។",
      "annotaionFixSuccess": "កែប្រែបញ្ហាបានជោគជ័យ",
      "nonAnnotation": "មិនមានចំណារដែលបានជ្រើសរើស ឬមានបញ្ហាទំនាក់ទំនង",
      "projectLoading": "កំពុងផ្ទុកគម្រោង...",
      "notMyProject": "នេះជាគម្រោងដែលអ្នកមិនមាន។",
      "layerLoading": "កំពុងផ្ទុកព័ត៌មានស្រទាប់...",
      "creationAnnotation": "ការបង្កើតចំណារបានបញ្ចប់",
      "failedCreationAnnotation": "ការបង្កើតចំណារបានបរាជ័យ",
      "loadingFilterInfo": "កំពុងផ្ទុកព័ត៌មានច្រោះ...",
      "successDeleting": "ការលុបបានជោគជ័យ។",
      "failedDeleting": "ការលុបបានបរាជ័យ។",
      "loadingLongitudianlInfo": "កំពុងផ្ទុកព័ត៌មានផ្នែក...",
      "outOfRangeMessage": "ចាកចេញពីតំបន់គោលដៅ។",
      "loadingIssuelInfo": "កំពុងផ្ទុកព័ត៌មានបញ្ហា...",
      "errorLoadLongitudinalInfo": "មិនអាចផ្ទុកព័ត៌មានផ្នែកបានទេ។",
      "loadingPage": "កំពុងផ្ទុកទំព័រ...",
      "loadingData": "កំពុងផ្ទុកទិន្នន័យ...",
      "loadingAnnotation": "កំពុងផ្ទុកចំណារ...",
      "checkPositionByClickingMap": "សូមចុចលើផែនទីដើម្បីពិនិត្យកូអរដោនេ។",
      "loadingMeasurementInfo": "កំពុងផ្ទុកព័ត៌មានការវាស់ស្ទង់...",
      "noMeasure": "គ្មានព័ត៌មានការវាស់ស្ទង់។",
      "noLength": "គ្មានព័ត៌មានកម្ពស់។",
      "noDSM": "គ្មានព័ត៌មាន DSM។",
      "noLayer": "គ្មានស្រទាប់។",
      "pleaseSelectACrossSection": "ជ្រើសរើសផ្នែក",
      "noCrossSection": "ចាកចេញពីតំបន់គោលដៅ។",
      "validateStepDigit": "សូមបញ្ចូលតួលេខអតិបរិមា ២ ខ្ទង់ និងទសភាគ ១ ខ្ទង់។",
      "validateStepLength": "សូមបញ្ចូលចន្លោះតូចជាងប្រវែងរបស់ស្រទាប់នីមួយៗ។",
      "longitudinalIntervalError": "សូមបញ្ចូលចន្លោះចំណុចក្នុងលក្ខខណ្ឌ ២ ខ្ទង់ ទសភាគ ១ ខ្ទង់ យ៉ាងតិច ១ ម។",
      "longitudinalWidthError": "ទទឹងខាងឆ្វេង-ស្ដាំត្រូវតែធំជាងចន្លោះចំណុច។",
      "startOverEnd": "ថ្ងៃចាប់ផ្ដើមមានក្រោយថ្ងៃបញ្ចប់។",
      "endBeforeStart": "ថ្ងៃបញ្ចប់មានមុនថ្ងៃចាប់ផ្ដើម។",
      "createdOverStart": "ថ្ងៃចាប់ផ្ដើមមានមុនថ្ងៃបង្កើតគម្រោង។",
      "loading3DTiles": "កំពុងផ្ទុកទិន្នន័យគំរូ Mesh...",
      "loading3DTilesError": "ការផ្ទុកគំរូ Mesh បានបរាជ័យ។"
    }
  },
  "inspection3d": {
    "layers": "ស្រទាប់",
    "model": "គំរូ",
    "issue": "បញ្ហា",
    "measure": "ការវាស់ស្ទង់",
    "profile": "ប្លង់ផ្នែក 3D",
    "distance": "ចម្ងាយ",
    "lowQuality": "គុណភាពទាប",
    "highQuality": "គុណភាពខ្ពស់",
    "opacity": "ភាពថ្លា",
    "msg": {
      "underMaintenance": "ការថែទាំមុខងារ",
      "loading3DModel": "កំពុងបង្កើតគំរូ 3D",
      "modelServerError": "កំហុសសម្ព័ន្ធ 3D។",
      "modelError": "ការបង្កើតគំរូ 3D បានបរាជ័យ។",
      "syncLayer": "កំពុងធ្វើសមកាលកម្មព័ត៌មានស្រទាប់",
      "syncLayerError": "ការធ្វើសមកាលកម្មព័ត៌មានស្រទាប់បានបរាជ័យ",
      "noModel": "គ្មានគំរូដែលបានបង្កើត។",
      "noIssues": "គ្មានបញ្ហា",
      "syncIssues": "កំពុងធ្វើសមកាលកម្មបញ្ហា",
      "issueLoadError": "ការផ្ទុកបញ្ហាបានបរាជ័យ",
      "issueCreationSuccess": "ការបង្កើតបញ្ហាបានជោគជ័យ",
      "issueCreationError": "ការបង្កើតបញ្ហាបានបរាជ័យ",
      "issueSaveSuccess": "ការរក្សាទុកបញ្ហាបានបញ្ចប់",
      "issueSaveError": "ការរក្សាទុកបញ្ហាបានបរាជ័យ",
      "issueDeleteSuccess": "ការលុបបញ្ហាបានបញ្ចប់",
      "issueDeleteError": "ការលុបបញ្ហាបានបរាជ័យ",
      "issueAreaError": "ការបង្កើតបញ្ហាអាចធ្វើបានក្នុងតំបន់គំរូ។",
      "profileAreaError": "ការបង្កើតប្លង់ផ្នែកអាចធ្វើបានក្នុងតំបន់គំរូ។",
      "imageAreaError": "ការមើលរូបភាពអាចធ្វើបានក្នុងតំបន់គំរូ។",
      "measurementAreaError": "ការវាស់ស្ទង់អាចធ្វើបានក្នុងតំបន់គំរូ។",
      "twoPointCountError": "សូមបង្កើតចំណុចយ៉ាងតិច ២។",
      "threePointCountError": "សូមបង្កើតចំណុចយ៉ាងតិច ៣។",
      "rightClickHint": "ចុចស្ដាំដើម្បីបោះបង់",
      "doubleClickConfirm": "ចុចពីរដងដើម្បីបញ្ជាក់",
      "profileSectionSummary": "ចន្លោះ {{count}} · សរុប {{length}} m",
      "leftClickRemove": "ចុចឆ្វេងដើម្បីលុប",
      "clickToLoadImage": "ចុចដើម្បីមើលរូបភាពនៅជិត",
      "profileCoordinateLoading": "កំពុងគណនាកូអរដោនេ",
      "measurementRightClick": "ចុចស្ដាំដើម្បីបញ្ចប់",
      "getNearbyImages": "ចុចដើម្បីផ្ទុករូបភាពនៅជិត។",
      "switchingTimeSeries": "កំពុងប្តូរស៊េរីពេលវេលា...",
      "loadingModelList": "កំពុងពិនិត្យបញ្ជីម៉ូដែល...",
      "loadingModelInfo": "កំពុងផ្ទុកព័ត៌មានម៉ូដែល 3D...",
      "loadingModelTiles": "កំពុងគូរម៉ូដែល 3D...",
      "meshLoadFailed": "បរាជ័យក្នុងការផ្ទុកម៉ូដែល {{name}}",
      "meshLoadStalled": "មិនអាចផ្ទុកទិន្នន័យមួយចំនួនបានទេ",
      "meshLoadStalledNamed": "មិនអាចផ្ទុកទិន្នន័យ {{names}} បានទេ",
      "meshLoadAllFailed": "មិនអាចផ្ទុកម៉ូដែល 3D បានទេ",
      "retry": "ព្យាយាមម្តងទៀត",
      "loadingBim": "កំពុងផ្ទុក BIM...",
      "loadingPointCloud": "កំពុងផ្ទុក Point Cloud...",
      "loadingGisLayers": "កំពុងផ្ទុកស្រទាប់ GIS...",
      "loadingLinearLayers": "កំពុងផ្ទុកស្រទាប់លីនេអ៊ែរ...",
      "stageBim": "BIM",
      "stagePointCloud": "Point Cloud",
      "stageGis": "ស្រទាប់ GIS",
      "stageLinear": "ស្រទាប់លីនេអ៊ែរ",
      "stageLoadFailed": "បរាជ័យក្នុងការផ្ទុក {{name}} — រំលងទៅបន្ត",
      "stageLoadStalled": "ការផ្ទុក {{name}} យឺតពេក — រំលងទៅបន្ត",
      "layerLoadFailed": "បរាជ័យក្នុងការផ្ទុកស្រទាប់ {{name}}"
    },
    "measureAxis": {
      "axisSolid": "3D",
      "axisPlane": "ផ្ដេក",
      "axisHeight": "កម្ពស់",
      "axisHorizontal": "ផ្ដេក",
      "axisSolidArea": "ផ្ទៃ 3D",
      "axisPlaneArea": "ផ្ទៃផ្ដេក"
    },
    "tooltip": {
      "showHide": "បង្ហាញ/លាក់",
      "flyToLayer": "ផ្លាស់ទីទៅម៉ូដែល",
      "flyToMesh": "ផ្លាស់ទីទៅម៉ូដែល",
      "adjustOpacity": "កែប្រែភាពថ្លា",
      "help": {
        "showHide": "បង្ហាញ/លាក់ស្រទាប់",
        "flyToLayer": "ផ្លាស់ទីទៅម៉ូដែល",
        "adjustOpacity": "កែប្រែភាពថ្លា"
      }
    }
  },
  "mapTool": {
    "guide": {
      "button": {
        "click": "ចុច",
        "doubleClick": "ចុចពីរដង",
        "rightClick": "ចុចស្ដាំ",
        "release": "លែង",
        "drag": "អូស",
        "clickPlus": "ចុច (＋)",
        "rightClickPoint": "ចុចស្ដាំ (ចំណុច)"
      },
      "action": {
        "createPoint": "បង្កើតចំណុច",
        "finish": "បញ្ចប់",
        "cancel": "បោះបង់",
        "undo": "ត្រឡប់វិញ",
        "removeMeasurement": "លុបការវាស់",
        "nearbyImage": "មើលរូបភាពនៅជិត",
        "placeEquipment": "ដាក់",
        "movePoint": "ផ្លាស់ទីចំណុច",
        "removePoint": "លុបចំណុច",
        "appendPoint": "បន្ថែមចំណុចនៅចុង"
      },
      "precisePending": "កំពុងបង្កើតចំណុចច្បាស់លាស់…"
    }
  },
  "graph": {
    "checkCrossSection": "ពិនិត្យផ្នែកឆ្លង",
    "checkLongitudeSection": "ពិនិត្យផ្នែកបណ្ដោយ",
    "openSectionGraph": "បើកក្រាហ្វផ្នែក: {{target}}",
    "height": "កម្ពស់",
    "distance": "ចម្ងាយ",
    "line": "ខ្សែ",
    "alignment": "ការតម្រឹម",
    "lineLayerNotFound": "រកមិនឃើញទិន្នន័យខ្សែរបស់ស្រទាប់ដែលបានជ្រើស។ សូមទាក់ទងអ្នកគ្រប់គ្រង។",
    "layerToggleFailed": "ការផ្លាស់ប្ដូរស្រទាប់បានបរាជ័យ",
    "layerColorChangeFailed": "ការផ្លាស់ប្ដូរពណ៌ស្រទាប់បានបរាជ័យ",
    "stratum": "ស្រទាប់ដី",
    "designHeight": "កម្ពស់ការរចនា",
    "check": "ពិនិត្យ",
    "longitudeSection": "ផ្នែកបណ្ដោយ",
    "specificSection": "ជាក់លាក់",
    "crossSection": "ផ្នែកឆ្លង",
    "crossSectionList": "បញ្ជីផ្នែកឆ្លង",
    "perpendicularInterval": "ចន្លោះផ្នែកឆ្លង",
    "pointInterval": "ចន្លោះចំណុច",
    "pointSetting": "ការកំណត់ទីចំណុច",
    "detailSetting": "ការកំណត់លម្អិត",
    "startPoint": "ចំណុចចាប់ផ្ដើម",
    "endPoint": "ចំណុចបញ្ចប់",
    "section": "ផ្នែក",
    "sectionStartPoint": "ចំណុចចាប់ផ្ដើម",
    "sectionEndPoint": "ចំណុចបញ្ចប់",
    "original": "មើលដើម",
    "detail": "មើលលម្អិត",
    "startPointError": "ចំណុចចាប់ផ្ដើមមិនអាចតូចជាងតម្លៃដើមបានទេ។",
    "enterBranch": "សូមបញ្ចូលទីចំណុច។",
    "validate": {
      "dxfSaveFileDownloadError": "មានកំហុសក្នុងការទាញយកឯកសារ។ សូមសាកល្បងម្ដងទៀត។",
      "dxfSaveFileGenerateNotice": "ការស្នើសុំបង្កើតឯកសារត្រូវបានធ្វើឡើង។ ជាធម្មតាបញ្ចប់ក្នុង ១០ នាទី។ សូមមើលបន្ទាប់ពីបន្តិច។",
      "dxfSaveFileGenerateError": "ការបង្កើតឯកសារបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
      "noSavedData": "គ្មានទិន្នន័យដែលបានរក្សាទុក។",
      "failDeleteData": "ការលុបទិន្នន័យបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀត។",
      "savePerpendicular": "ផ្នែកឆ្លងត្រូវបានរក្សាទុក។",
      "deletePerpendicular": "ផ្នែកឆ្លងត្រូវបានលុប។",
      "existingCrossSection": "មានផ្នែកឆ្លងដែលបានរក្សាទុករួចហើយ។ សូមលុបហើយសាកល្បងម្ដងទៀត។",
      "longitudinalPointIntervalMinValue": "ត្រូវតែ ១ ឬច្រើនជាង។",
      "perpendicularIntervalMinValue": "ត្រូវតែ ១ ឬច្រើនជាង។",
      "perpendicularWidthMinValue": "ត្រូវតែ ១ ឬច្រើនជាង។",
      "duplicatePointError": "មានទីចំណុចដូចគ្នា។ សូមពិនិត្យទីចំណុចដែលស្ទួន។",
      "endPointInfo": "ប្រសិនបើមិនបញ្ចូលចំណុចបញ្ចប់ ឬចំណុចបញ្ចប់វែងជាងខ្សែ អ្នកនឹងឃើញផ្នែកទាំងមូល។",
      "lngStartPoint": "ចំណុចចាប់ផ្ដើមផ្នែកបណ្ដោយត្រូវបានឆ្លុះក្នុងឯកសារ TEXT តែប៉ុណ្ណោះ។",
      "startStepError": "ចំណុចចាប់ផ្ដើមមិនអាចតូចជាងតម្លៃដើមបានទេ។",
      "endStepError": "ចំណុចបញ្ចប់មិនអាចតូចជាងចំណុចចាប់ផ្ដើមបានទេ។",
      "sameStepError": "ចំណុចចាប់ផ្ដើមនិងចំណុចបញ្ចប់មិនអាចដូចគ្នា។",
      "performanceWarning": "កម្មវិធីរុករកអាចឈប់ដំណើរការអាស្រ័យលើប្រតិបត្តិការណ៍កុំព្យូទ័រ។ ប្រសិនបើឈប់ សូមតាំងពិតថ្មីហើយបង្កើនចន្លោះចំណុច ឬកាត់បន្ថយផ្នែក។",
      "maxStratumFilesSelected": "អាចជ្រើសរើសឯកសារបានអតិបរិមា ៣ ។",
      "maxStep": "ចន្លោះត្រូវតែ ១០០ ឬតិចជាង។",
      "increment": "ចន្លោះត្រូវតែជាពហុគុណ ៥។",
      "equal": "ចន្លោះចំណុចត្រូវតែស្មើឬតូចជាងចន្លោះផ្នែកឆ្លង។",
      "setPoint": "សូមកំណត់ចំណុចចាប់ផ្ដើមនិងចំណុចបញ្ចប់",
      "pointAdditionError": "ទីចំណុចបន្ថែមមិនអាចតូចជាងចំណុចចាប់ផ្ដើមបានទេ។",
      "pointAdded": "ផ្នែកឆ្លងជាក់លាក់ត្រូវបានបន្ថែម។",
      "pointAdditionFailed": "ការបន្ថែមផ្នែកឆ្លងជាក់លាក់បានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
      "pointAdditionTargetFailed": "មានផ្នែកឆ្លងនៅចម្ងាយនោះហើយ។ សូមពិនិត្យចម្ងាយដែលបានបញ្ចូល។",
      "distanceExceedsSegmentLength": "ចម្ងាយដែលបានបញ្ចូលលើសជាងប្រវែងខ្សែ។",
      "crossSectionDeletionFailed": "ការលុបផ្នែកឆ្លងបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។"
    }
  },
  "myPage": {
    "accountInfo": "ព័ត៌មានគណនី",
    "quit": "លុបសមាជិកភាព",
    "quitAgreement": "ការយល់ព្រមលុបសមាជិកភាព",
    "quitAggrementDescription": {
      "first": "ព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នកប្រើប្រាស់នឹងត្រូវបំផ្លាញភ្លាមៗបន្ទាប់ពីសម្រេចគោលបំណង។ ទោះជាយ៉ាងណា ព័ត៌មានដែលត្រូវរក្សាទុកតាមច្បាប់នឹងត្រូវចែករក្សាទុកក្នុងរយៈពេលដែលច្បាប់កំណត់ហើយបំផ្លាញ។",
      "second": "   ក. នីតិវិធីនិងរយៈពេលបំផ្លាញ ព័ត៌មានផ្ទាល់ខ្លួនដែលសម្រេចគោលបំណងនឹងត្រូវបំផ្លាញភ្លាមៗ ហើយប្រសិនបើត្រូវរក្សាទុកតាមច្បាប់ពាក់ព័ន្ធ ត្រូវបានផ្ទេរទៅ DB ដាច់ដោយឡែក ហើយរក្សាទុកក្នុងរយៈពេលជាក់លាក់ (រយៈពេលកាន់ក្រោយ/ប្រើប្រាស់ព័ត៌មានផ្ទាល់ខ្លួន) ដោយសុវត្ថិភាព ហើយបំផ្លាញភ្លាមៗ។ ក្នុងករណីនេះ ព័ត៌មានដែលបានផ្ទេរទៅ DB មិនត្រូវប្រើប្រាស់ក្នុងគោលបំណងផ្សេងទៀត លើកលែងតែតាមច្បាប់។",
      "third": " ខ. វិធីសាស្ត្របំផ្លាញ ព័ត៌មានក្នុងទម្រង់ឯកសារអ៊ីនធឺណិតត្រូវបំផ្លាញទាំងស្រុងដោយប្រើបច្ចេកទេសដែលមិនអាចស្ដារ ឬបង្កើតឡើងវិញបាន។ ព័ត៌មានដែលបោះពុម្ពត្រូវបំផ្លាញដោយម៉ាស៊ីនកាត់ ឬវិធីសាស្ត្រសមស្រប។",
      "fourth": "ខ្ញុំបានពិនិត្យសម្ភារៈណែនាំទាំងអស់ ហើយយល់ព្រម។"
    },
    "msg": {
      "atLeastOneSpecialCharacter": "ពាក្យសម្ងាត់ត្រូវមានតួអក្សរពិសេសយ៉ាងតិច ១។",
      "atLeastOneDigit": "ពាក្យសម្ងាត់ត្រូវមានលេខយ៉ាងតិច ១។",
      "passwordLength": "ពាក្យសម្ងាត់ត្រូវតែមានអក្សរ ៨ ឬច្រើនជាង។",
      "atLeastOneLowerCaseLetter": "ពាក្យសម្ងាត់ត្រូវមានអក្សរតូចយ៉ាងតិច ១។",
      "passwordNeedCapital": "ពាក្យសម្ងាត់ត្រូវមានអក្សរធំយ៉ាងតិច ១។",
      "onlyNumber": "សូមបញ្ចូលលេខតែប៉ុណ្ណោះ។",
      "notEnoughLength": "ប្រវែងមិនត្រឹមត្រូវ។",
      "checkVerifyingEmail": "សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់ដែលបានផ្ញើទៅអ៊ីមែល។",
      "makeSureQuiteQuestion": "តើអ្នកចង់លុបសមាជិកភាព?",
      "makeSureQuitDoubleCheck": {
        "ko": "회원 탈퇴를 원하신다면, '계정 삭제' 를 입력해 주세요.",
        "en": "If you wish to withdraw your membership, please enter &quot;Account Deletion",
        "km": "ប្រសិនបើអ្នកចង់លុបសមាជិកភាព សូមបញ្ចូល 'លុបគណនី'។",
        "checkWord": "លុបគណនី"
      },
      "checkDuplicatedEmail": "សូមពិនិត្យការស្ទួនអ៊ីមែល។",
      "idAllowEngNumber": "សូមបញ្ចូលទម្រង់អ៊ីមែលត្រឹមត្រូវ។",
      "emailAlreadyExists": "ID នេះមានស្រាប់ហើយ។",
      "newtworkError": "មិនអាចពិនិត្យការស្ទួនបានដោយសារបញ្ហាបណ្ដាញ។",
      "usableEmail": "អ៊ីមែលអាចប្រើបាន។",
      "notMatchPassword": "ពាក្យសម្ងាត់មិនត្រូវគ្នា។",
      "failedModifiedUser": "ការកែប្រែព័ត៌មានសមាជិកបានបរាជ័យ។",
      "warningTypicalform": "សូមបញ្ចូលក្នុងទម្រង់",
      "warningQuitDescription": "សូមពិនិត្យនិងយល់ព្រមព័ត៌មានណែនាំការលុប។",
      "joinCompleted": "ការចុះឈ្មោះបានបញ្ចប់។",
      "accountDeleted": "គណនីត្រូវបានលុប។"
    }
  },
  "userManagement": {
    "manageProjectPermission": "ការគ្រប់គ្រងសិទ្ធិគម្រោង",
    "addUser": "បន្ថែមអ្នកប្រើប្រាស់",
    "delete": "លុប",
    "joinStatus": "ស្ថានភាពចូលរួម",
    "joined": "ចូលរួម",
    "unjoined": "មិនបានចូលរួម",
    "msg": {
      "userAdding": "កំពុងដំណើរការការផ្លាស់ប្ដូរ។",
      "userAdded": "អ្នកប្រើប្រាស់ត្រូវបានបន្ថែម។",
      "userDeleted": "អ្នកប្រើប្រាស់ត្រូវបានលុប។",
      "userEdited": "សិទ្ធិអ្នកប្រើប្រាស់ត្រូវបានកែប្រែ។",
      "confirmUserDelete": "តើអ្នកចង់លុបអ្នកប្រើប្រាស់ចេញពីគម្រោង?",
      "errorUserEdit": "មិនអាចកែប្រែបានដោយសារបញ្ហាបណ្ដាញ។",
      "errorUserDelete": "មិនអាចលុបបានដោយសារបញ្ហាបណ្ដាញ។",
      "projectFirst": "សូមបង្កើតគម្រោងជាមុន។",
      "projectsListing": "កំពុងផ្ទុកបញ្ជីគម្រោង។"
    }
  },
  "header": {
    "service": "សេវាកម្ម",
    "platform": "វេទិកា",
    "survey": "ការស្ទង់ Drone / ការដំណើរការទិន្នន័យដែន",
    "plan": "ផែនការប្រើប្រាស់",
    "contact": "ទាក់ទង ១:១",
    "manual": "ការណែនាំ",
    "project": "គម្រោង",
    "myPage": "ទំព័ររបស់ខ្ញុំ",
    "auth": {
      "login": "ចូលប្រព័ន្ធ",
      "logging": "កំពុងចូលប្រព័ន្ធ...",
      "logout": "ចាកចេញ",
      "join": "ចុះឈ្មោះ",
      "sendingcode": "កំពុងផ្ញើលេខកូដ...",
      "changepw": "ផ្លាស់ប្ដូរពាក្យសម្ងាត់",
      "changingpw": "កំពុងផ្លាស់ប្ដូរពាក្យសម្ងាត់...",
      "verifyemail": "ផ្ទៀងផ្ទាត់អ៊ីមែល"
    }
  },
  "sideNav": {
    "error": {
      "nonProject": "សូមជ្រើសរើសគម្រោងមួយ។"
    }
  },
  "constants": {
    "text": "អត្ថបទ",
    "polygon": "ពហុជ្រុង",
    "rectangle": "ចតុកោណ",
    "marker": "សញ្ញា",
    "severity": "ភាពធ្ងន់ធ្ងរ",
    "importance": "សារៈសំខាន់",
    "urgenty": "ភាពបន្ទាន់",
    "imageupload": "បង្ហោះរូបភាព",
    "checkall": "ជ្រើសរើសទាំងអស់",
    "distance": "ចម្ងាយ(ម)",
    "height": "កម្ពស់(ម)",
    "pointBim": "Point BIM",
    "image": "រូបភាព",
    "optimizedImage": "(ប្រសិទ្ធ/ដើម)",
    "video": "វីដេអូ",
    "document": "ឯកសារ",
    "layer": "ស្រទាប់",
    "noLayer": "គ្មានស្រទាប់អាចជ្រើសរើស។",
    "layerSelect": "សូមជ្រើសរើសស្រទាប់។",
    "projectName": "ឈ្មោះគម្រោង",
    "project": "គម្រោង",
    "address": "អាសយដ្ឋាន",
    "position": "កូអរដោនេ (Lat/Lng)",
    "infraType": "ប្រភេទហេដ្ឋារចនាសម្ព័ន្ធ",
    "goBack": "ត្រឡប់",
    "opacity": "ភាពថ្លា",
    "loadingCalInfo": "កំពុងផ្ទុកព័ត៌មានការវាស់ស្ទង់...",
    "searchAddress": "ស្វែងរកអាសយដ្ឋាន",
    "requiredValue": "តម្លៃចាំបាច់។",
    "handsOnWriting": "បញ្ចូលដោយខ្លួនឯង",
    "updatedDate": "ថ្ងៃកែប្រែ",
    "completedDate": "ថ្ងៃបញ្ចប់",
    "completed": "បញ្ចប់",
    "objectType": "ប្រភេទវត្ថុ",
    "memo": "កំណត់ចំណាំ",
    "tag": "ស្លាក",
    "keyword": "ពាក្យគន្លឹះ",
    "cancel": "បោះបង់",
    "save": "រក្សាទុក",
    "makeIssueTitle": "សូមបញ្ចូលចំណងជើងបញ្ហា។",
    "modify": "កែប្រែ",
    "other": "ផ្សេងៗ",
    "deleting": "លុប",
    "delete": "លុប",
    "search": "ស្វែងរក",
    "add": "បន្ថែម",
    "remove": "ដកចេញ",
    "issueList": "បញ្ជីបញ្ហា",
    "type": "ប្រភេទ",
    "beforeProcess": "មុនដំណើរការ",
    "processing": "កំពុងដំណើរការ",
    "processCompleted": "ដំណើរការបានបញ្ចប់",
    "processFailed": "ដំណើរការបានបរាជ័យ",
    "twoDimensionImage": "រូបភាព 2D",
    "threeDimensionImage": "រូបភាព 3D",
    "requestedProcess": "ស្នើសុំដំណើរការ",
    "checkingRequest": "កំពុងត្រួតពិនិត្យ",
    "coordinateSystem": "ប្រព័ន្ធកូអរដោនេចេញ",
    "resolution": "គុណភាព (GSD)",
    "download": "ទាញយក",
    "update": "ធ្វើបច្ចុប្បន្នភាព",
    "downing": "កំពុងទាញ",
    "checking": "កំពុងពិនិត្យ",
    "createFile": "បង្កើតឯកសារ",
    "creating": "កំពុងបង្កើត",
    "group": "ក្រុម",
    "preview": "មើលជាមុន",
    "none": "គ្មាន",
    "edit": "កែប្រែ",
    "editModeMeasureNotice": "តម្លៃគណនានឹងត្រូវបានធ្វើបច្ចុប្បន្នភាពនៅពេលអ្នកចេញពីរបៀបកែប្រែ",
    "volumeCalculationFailed": "ការគណនាបរិមាត្របានបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
    "orthomosaicImage": "រូបភាព Orthomosaic",
    "gisLayer": "ស្រទាប់ GIS",
    "subLayer": "ស្រទាប់ជំនួយ",
    "annotation": "ចំណារ",
    "latitude": "រយៈទទឹង",
    "latitudeShorten": "រយៈទទឹង",
    "longitude": "រយៈបណ្ដោយ",
    "longitudeShorten": "រយៈបណ្ដោយ",
    "location": "ទីតាំង",
    "create": "បង្កើត",
    "annotationType": "ប្រភេទចំណារ",
    "issueDescription": "ការពិពណ៌នាបញ្ហា",
    "issueDegree": "កម្រិតបញ្ហា",
    "issueGrade": "ថ្នាក់បញ្ហា",
    "createIssue": "បង្កើតបញ្ហា",
    "date": "កាលបរិច្ឆេទ",
    "createdDate": "ថ្ងៃបង្កើត",
    "reset": "ដំណើរការឡើងវិញ",
    "check": "ពិនិត្យ",
    "filtering": "ច្រោះ",
    "totalIssue": "បញ្ហាសរុប",
    "cases": " ករណី",
    "measurement": "ការវាស់ស្ទង់",
    "information": " ព័ត៌មាន",
    "coordinates": "កូអរដោនេ",
    "area": "ផ្ទៃ",
    "surfaceArea": "ផ្ទៃដី",
    "line": "ខ្សែ",
    "length": " ប្រវែង",
    "elevationDifference": "ភាពខុសគ្នានៃកម្ពស់",
    "slope": "ជម្រាល",
    "volume": "ទំហំ",
    "setFloorHeight": "កម្ពស់ ​ជាន់ (ម)",
    "volumeCalculate": "ការគណនាទំហំ",
    "volumeBaseMode": "ផ្ទៃបាត",
    "baseModeCustom": "បញ្ចូលកម្ពស់គោលដោយផ្ទាល់",
    "baseModeTriangulated": "បណ្ដាញត្រីកោណចំណុចព្រំដែន",
    "baseModeMean": "កម្ពស់មធ្យមចំណុចព្រំដែន",
    "volumeGuideTitle": "មគ្គុទ្ទេសក៍គណនាបរិមាត្រ",
    "volumeGuideOpen": "បើកមគ្គុទ្ទេសក៍គណនាបរិមាត្រ",
    "close": "បិទ",
    "baseModeCustomDesc": "គណនាបរិមាត្រដោយផ្អែកលើផ្ទៃផ្ដេកដែលបង្កើតពីកម្ពស់ដែលបានបញ្ចូល។ ខាងលើផ្ទៃគឺជាបរិមាណកាត់ដី ខាងក្រោមគឺជាបរិមាណបំពេញដី។",
    "baseModeTriangulatedDesc": "តភ្ជាប់ចំណុចកំពូលនៃព្រំដែនពហុកោណជាបណ្ដាញត្រីកោណ (TIN) ហើយគណនាបរិមាត្រដោយផ្អែកលើផ្ទៃបាតដែលតាមជម្រាលដី។",
    "baseModeMeanDesc": "គណនាបរិមាត្រដោយផ្អែកលើផ្ទៃផ្ដេកនៃកម្ពស់ដីមធ្យមរបស់ចំណុចកំពូលព្រំដែនពហុកោណ។",
    "volumeOutOfRasterBounds": "តំបន់វាស់ស្ថិតនៅក្រៅជួរទិន្នន័យកម្ពស់ដី ដូច្នេះមិនអាចគណនាបរិមាត្របានទេ។",
    "crossSection": "ផ្នែក",
    "sectionAndCrossSection": "ផ្នែក · ផ្នែកឆ្លង",
    "startingSidePoint": "ចំណុចស្ទង់ចាប់ផ្ដើម",
    "setSpacing": "ការកំណត់ចន្លោះ",
    "checkTheCrossSection": "ពិនិត្យផ្នែក",
    "cutVolume": "CUT (ការកាត់)",
    "fillVolume": "FILL (ការបំពេញ)",
    "netVolume": "ទំហំសុទ្ធ",
    "settingInterval": "ចន្លោះផ្នែក (ម)",
    "startingSurveyPoint": "ចំណុចស្ទង់ចាប់ផ្ដើម (ម)",
    "checkCrossSection": "ពិនិត្យផ្នែក",
    "longitudeGraph": "ប្រវត្តិរូបកម្ពស់",
    "longitudeSliderNotice": "ប្រើ Slider ខាងស្ដាំដើម្បីកែលម្អបរិមាណទិន្នន័យដែលផ្ដោតលើចំណុចផ្លាស់ប្ដូរខ្លាំងក្នុងប្រវត្តិរូបកម្ពស់។",
    "longitudeDetailNotice": "សូមបញ្ចូលចន្លោះចំណុចនៃផ្នែកដែលអ្នកចង់មើលលម្អិតក្នុងក្រាហ្វ ហើយជ្រើសរើសចំណុចចាប់ផ្ដើមនិងចំណុចបញ្ចប់។",
    "perpendicular": "ផ្នែកបណ្ដោយ-ឆ្លង",
    "perpendicularGraph": "ប្រវត្តិរូបកម្ពស់ផ្នែកឆ្លង",
    "perpendicularWidth": "ការកំណត់ទទឹង",
    "left": "ឆ្វេង",
    "right": "ស្ដាំ",
    "perpendicularInterval": "ចន្លោះផ្នែកឆ្លង",
    "longitudeGraphPart": "មើលខ្លះ",
    "longitudeGraphTotal": "មើលទាំងអស់",
    "total2DLength": "ប្រវែង 2D សរុប",
    "total3DLength": "ប្រវែង 3D សរុប",
    "planeDistance": "ចម្ងាយផ្ដេក",
    "solidDistance": "ចម្ងាយ 3D",
    "surfaceDistance": "ចម្ងាយផ្ទៃដី",
    "planeArea": "ផ្ទៃផ្ដេក",
    "solidArea": "ផ្ទៃ 3D",
    "planeDistanceTooltip": "ចម្ងាយខ្សែត្រង់ដែលបាន Projet ផ្ដេក ដោយមិនអើពើកម្ពស់។",
    "solidDistanceTooltip": "ចម្ងាយខ្សែត្រង់ 3D រវាងចំណុច 2 ដែលរួមបញ្ចូលភាពខុសគ្នានៃកម្ពស់។",
    "surfaceDistanceTooltip": "ចម្ងាយពិតតាមផ្ទៃដីភូមិ (mesh)។",
    "planeAreaTooltip": "ផ្ទៃដែលបាន Projet ផ្ដេក ដោយមិនអើពើកម្ពស់។",
    "solidAreaTooltip": "ផ្ទៃដែលភ្ជាប់ចំណុចនៃទ្រង់ទ្រាយ 3D ដោយរាប់បញ្ចូលភាពខុសគ្នានៃកម្ពស់។",
    "surfaceAreaTooltip": "ផ្ទៃពិតនៃផ្ទៃដីភូមិ (mesh) រួមបញ្ចូលភ្ជួរ។",
    "upload": "បង្ហោះ",
    "totalAmount": "ទំហំសរុប",
    "writer": "អ្នកសរសេរ",
    "organization": "ស្ថាប័ន",
    "title": "ចំណងជើង",
    "rank": "ថ្នាក់",
    "email": "អ៊ីមែល",
    "permission": "សិទ្ធិ",
    "createReport": "បង្កើតរបាយការណ៍",
    "id": "ID",
    "username": "ឈ្មោះ",
    "no": "លេខ",
    "phone": "លេខទូរស័ព្ទ",
    "major": "វិស័យ",
    "job": "មុខតំណែង",
    "mypage": "ទំព័ររបស់ខ្ញុំ",
    "heightProfile": "ប្រវត្តិរូបកម្ពស់",
    "imageList": "បញ្ជីរូបភាព",
    "total": "សរុប",
    "imagesCounting": "ចំនួន",
    "all": "ទាំងអស់",
    "near": "ជិត",
    "noneImages": "គ្មានរូបភាព។",
    "loadingImages": "កំពុងផ្ទុករូបភាព",
    "requestMapping": "ស្នើសុំ",
    "requestCompleted": "ការស្នើសុំបានបញ្ចប់",
    "password": "ពាក្យសម្ងាត់",
    "doubleCheck": "បញ្ជាក់ពាក្យសម្ងាត់",
    "linkPositions": "ភ្ជាប់ទីតាំង",
    "idDoubleCheck": "ពិនិត្យការស្ទួន",
    "user": "អ្នកប្រើប្រាស់",
    "submit": "ផ្ទៀងផ្ទាត់",
    "resend": "ផ្ញើឡើងវិញ",
    "next": "បន្ទាប់",
    "code": "លេខកូដ",
    "filter": "ច្រោះ",
    "apply": "អនុវត្ត",
    "acquired": "ថ្ងៃថត"
  },
  "pdf": {
    "author": "អ្នក​សរ​សេរ",
    "organization": "ស្ថា​ប័ន",
    "rank": "មុខ​តំ​ណែង",
    "email": "អ៊ី​មែ​ល",
    "report": " របាយការណ៍",
    "groupAssociations": "ការភ្ជាប់ក្រុម",
    "issue": "បញ្ហា",
    "issueName": "ឈ្មោះបញ្ហា",
    "count": "ចំនួន",
    "layout": "ប្លង់",
    "summary": "សង្ខេប",
    "issueLevel": "កម្រិតបញ្ហា",
    "issueType": "ប្រភេទបញ្ហា",
    "issuePriority": "អាទិភាព",
    "comment": "មតិ",
    "acquired": "ថ្ងៃទទួលទិន្នន័យ",
    "msg": {
      "loadingPdf": "កំពុងផ្ទុក PDF..."
    }
  },
  "pricing": {
    "standard1": "ការជាវប្រចាំខែ",
    "standard1_2": "(រក្សាការស្ទួនរូបភាពលើស ៨០%)",
    "standard2": "រូបភាព Drone ៣០០០/ ការកសាងគម្រោង Drone",
    "standard3": "ដំណើរការទិន្នន័យ ២ ដង/ខែ",
    "standard4": "ទាញយកលទ្ធផលការជ្រើសតម្រួតរូបភាព",
    "advanced1": "ការជាវប្រចាំឆ្នាំ ដែលជម្រើសការប្រើប្រាស់ត្រូវបានពិភាក្សាយ៉ាងបត់បែន",
    "advanced1_2": "",
    "contactUs": "ទាក់ទង",
    "title": "ផែនការសេវាកម្ម DroneSquare",
    "description1": "ដំណើរការការត្រួតពិនិត្យ និងការថែទាំល្អបំផុតដោយ",
    "description2": "ការវិភាគទិន្នន័យត្រឹមត្រូវដែលផ្ដល់ដោយ DroneSquare។",
    "standard_subtitle": "សម្រាប់ករណីចង់វិភាគ និងគ្រប់គ្រងវត្ថុគោលដៅ (ទីតាំង) ចំនួនតិច",
    "advanced_subtitle": "សម្រាប់ករណីចង់វិភាគ និងគ្រប់គ្រងវត្ថុគោលដៅ (ទីតាំង) ចំនួនច្រើន"
  }
} as const;

export default common;
